export default {
  UserPoolId: 'us-east-1_yPxq0YyPV',
  ClientId: '5htn00k77dvn48vud91p7er356'
}